itsoftApp.createModule("switchText", function () {
    const module = this;

    const SwitchText = function () {
        this.container = document.querySelector('.js-switch-text');
        this.items = this.container && this.container.querySelectorAll('.js-switch-text-item');
        this.time = this.container && this.container.dataset.delay;
        this.index = 1;
        this.timeout = null;
        this.curEl = null;

        if (this.container) {
            this.init();
        }
    };

    SwitchText.prototype.toggleEl = function() {
        this.curEl = this.items[this.index];
        for (const el of this.items) {
            el.style.display = 'none';
        }
        this.curEl.style.display = '';
    };

    SwitchText.prototype.setIndex = function() {
        this.index++;
        if (this.index === this.items.length) {
            this.index = 0;
        }
    };

    SwitchText.prototype.start = function() {
        this.timeout = setTimeout(this.doAction, this.time);
    };


    SwitchText.prototype.refresh = function() {
        if (this.timeout) {
            clearTimeout(this.timeout);
            this.timeout = null;
            this.timeout = setTimeout(this.doAction, this.time);
        }
    };

    SwitchText.prototype.doAction = function () {
        this.toggleEl();
        this.setIndex();
        this.refresh();
    };

    SwitchText.prototype.init = function () {
        this.doAction = this.doAction.bind(this);
        this.start();
    };

    new SwitchText();
    module.callback = SwitchText;
});
